// @mui
import { Icon } from '@iconify/react/dist/iconify.js';
import { FormControl, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

// utils

// ----------------------------------------------------------------------

export default function CustomDropDown({ toggle, items }) {
    const [menu, setMenu] = useState(false)
    return (
        <Dropdown isOpen={menu} toggle={(e) => setMenu(!menu)} className="d-inline-block user-dropdown" style={{ paddingLeft: "5px", zIndex: "999" }}>
            <DropdownToggle tag="button" className="waves-effect border-0" style={{ borderRadius: "5px", minHeight: 40 }} id="page-header-user-dropdown">
                <Stack onClick={(e) => setMenu(true)}
                    p={"8px"}
                    sx={{
                        cursor: "pointer",
                        '&:hover': {
                            backgroundColor: 'transparent'
                        },
                    }}>{toggle}
                </Stack>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end mt-2">
                {
                    items?.length > 0 && items.map((el, idx) => {
                        return (
                            el.permission !== false &&
                            <DropdownItem
                                key={el.label}
                                className={"dropdown-item d-flex align-items-center"}
                                style={{ color: el.color || '#505D69' }}
                                onClick={(e) => el.onClick()}
                            >
                                {
                                    el?.isNotRemixIcon &&
                                    <Icon icon={el.iconName} fontSize={16} className='me-2' />
                                }
                                {
                                    !el?.isNotRemixIcon &&
                                    <i className={`${el.iconName} font-size-18 me-2`} />
                                }
                                {el.label}
                            </DropdownItem>
                        )
                    })
                }
            </DropdownMenu>
        </Dropdown>


    );
}


